import {use} from 'react'

import {
  PlanTypeSegmentedControl,
  type PlanType,
} from '../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'
import type {GenericContent} from '../../../../../brand/lib/types/contentful'

import {PlanTypeContext} from '../../_context/PlanTypeContext'
import type {PlanItem} from '../../content-plan-items'

type Props = {
  contentfulContent: GenericContent
  items: PlanItem[]
}

export function PlanTypes({contentfulContent, items}: Props) {
  const {planType, setPlanType} = use(PlanTypeContext)
  const heading = contentfulContent.fields.heading || 'Pricing plans'
  const handleChange = (nextPlanType: PlanType) => {
    // Primer Brand calls onChange from its internal state updater, so update the parent context after it completes.
    queueMicrotask(() => setPlanType(nextPlanType))
  }

  return (
    <div className="d-flex flex-justify-center px-2 tmp-mb-7">
      <h2 className="visually-hidden" id="pricing-plans">
        {heading}
      </h2>

      <PlanTypeSegmentedControl value={planType} onChange={handleChange} items={items} heading={heading} />
    </div>
  )
}
